// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24IXj","name":"styles_name__2t-80","phone":"styles_phone__1M_BW"};